import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import LogoTIProWithIconTI from '@components/Images/Rebranding/LogoTIProWithIconTI';
import LogoTIWithIconTI from '@components/Images/Rebranding/LogoTIWithIconTI';
import Modal from '@mui/material/Modal';

import StepComplete from './StepComplete';
import StepInterests, { Interest } from './StepInterests';
import StepNewsletters, { Newsletter } from './StepNewsletters';
import StepProfile from './StepProfile';
import StepReferralSource from './StepReferralSource';
import StepTopics, { Topic } from './StepTopics';
import StepUpdate from './StepUpdate';
import StepWelcome from './StepWelcome';

const queryClient = new QueryClient();

interface OnboardingModalProps {
  currentUserId: number;
  interests: Interest[];
  isProSubscriber: boolean;
  isUpdate: boolean;
  newsletters: Newsletter[];
  topics: Topic[];
  referralSource?: string;
}

const OnboardingModal = ({
  currentUserId,
  interests,
  isProSubscriber,
  isUpdate,
  newsletters,
  topics,
  referralSource,
}: OnboardingModalProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const [step, setStep] = useState(0);
  const isClosable = isUpdate;

  const handleClose = (_event: React.MouseEvent<HTMLButtonElement>, reason?: string) => {
    if (!isClosable && ['escapeKeyDown', 'backdropClick'].includes(reason)) return;
    setIsOpen(false);
  };

  const currentStep = () => {
    switch (step) {
      case 0:
        return (
          <>
            {isUpdate ? (
              <StepUpdate nextStep={() => setStep(1)} handleClose={handleClose} />
            ) : (
              <StepWelcome isProSubscriber={isProSubscriber} nextStep={() => setStep(1)} />
            )}
          </>
        );
      case 1:
        return <StepInterests nextStep={() => setStep(2)} interests={interests} />;
      case 2:
        return <StepTopics nextStep={() => setStep(3)} topics={topics} />;
      case 3:
        return <StepNewsletters nextStep={() => setStep(4)} newsletters={newsletters} />;
      case 4:
        return (
          <StepReferralSource
            nextStep={() => setStep(5)}
            currentUserId={currentUserId}
            CurrentReferralSource={referralSource}
          />
        );
      case 5:
        return (
          <StepProfile
            currentUserId={currentUserId}
            heading="Create Your Public Subscriber Profile"
            nextStep={() => setStep(6)}
            subheading="Join our exclusive community by adding your profile to the subscriber directory."
          />
        );
      case 6:
        return <StepComplete nextStep={handleClose} />;
      default:
        return null;
    }
  };

  return (
    <QueryClientProvider client={queryClient}>
      <Modal
        className="OnboardingModal"
        open={isOpen}
        onClose={handleClose}
        disableAutoFocus={true}
      >
        <div className="onboarding">
          <div className="onboarding-header">
            {isProSubscriber ? (
              <LogoTIProWithIconTI className="h-[35px] w-auto" />
            ) : (
              <LogoTIWithIconTI className="h-[35px] w-auto" />
            )}
          </div>
          {currentStep()}
        </div>
      </Modal>
    </QueryClientProvider>
  );
};

export default OnboardingModal;
